import { render } from "./TradingRecord.vue?vue&type=template&id=10976c73&scoped=true"
import script from "./TradingRecord.vue?vue&type=script&lang=js"
export * from "./TradingRecord.vue?vue&type=script&lang=js"

import "./TradingRecord.vue?vue&type=style&index=0&id=10976c73&scoped=true&lang=css"
import "./TradingRecord.vue?vue&type=style&index=1&id=10976c73&lang=scss"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\1h_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10976c73"]])

export default __exports__